/* import __COLOCATED_TEMPLATE__ from './help-center-filter-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();